<ion-header class="main-header">
  <ion-toolbar color="tertiary" class="mobile-visibility" [ngClass]="{'app-view-header': isApkWebView}">
    <div class="title-block title-block-custom">
      <div class="icon-title">
        <ion-icon name="arrow-back-outline" class="back-button" (click)="goBack()"></ion-icon>
        <ion-title class="title">P&L Statement</ion-title>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <!-- Dynamic Overlay -->
  <div class="overlay-container" *ngIf="showOverlay"></div>
  
  <div class="container panel-wrapper">
    <div class="header desktop-visibility">
      <img (click)="goBack()" src="../../../assets/svg/back-icon.svg" alt="img">
      <p>P&L Statement</p>
    </div>
    <div class="panel-content mt-0">
      <div class="search_filter_main">
        <div class="search_filter_grid">
          <div class="label">Select Family Member</div>
          <div class="select-wrapper client_with_pnl">
            <div class="select_client"  >
              <div class="main_select_box" (click)="clientClickpnl()">
                <div class="name-main">
                  <div>
                    <div class="short_name">{{getShortName(pnlClientName)}}</div>
                  </div>
                  <div class="title-width">
                    <span class="clientNameCss">{{pnlClientName}}</span>
                    <span class="hierarchyType">{{pnlDisplayRelation}}</span>
                  </div>
                </div>
                @if (pnlClientName) {
                  <ion-icon class="family-dropdown" slot="end" name="chevron-down"></ion-icon>
                }

              </div>
              @if (pnldropMain) {
                <div class="drop-main">
                  @if (pnlClientName) {
                    <div class="select_client_dropdown_main" id="ClientMainBoxPnl">
                      <ul class="select_client_dropdown">
                        @for (dataObj of familyMappList; track dataObj; let i = $index) {
                          <li class="client_box d-flex" (click)="pnlDropdownClicked(dataObj)">
                            <div class="short_name">{{getShortName(dataObj.ClientName ? dataObj.ClientName : "Name Not Available")}}</div>
                            <div class="name_details">
                              <span>{{dataObj.ClientName ? dataObj.ClientName : "Name Not Available"}}</span>
                              <label>{{dataObj.Relation && dataObj.Relation.length > 0 ? dataObj.Relation : 'SELF'}}</label>
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </div>
              }
            </div>

          </div>
        </div>
        <div class="search_filter_grid">
          <div class="label">Type of Report</div>
          <ion-segment class="calculator-segment" [(ngModel)]="yearDateOption" (ionChange)="segmentChangedYrDate($event.detail.value)">
            <ion-segment-button value="yearWise">Year Wise</ion-segment-button>
            <ion-segment-button value="dateWise">Date Wise</ion-segment-button>
          </ion-segment>
        </div>

        @if (yearDateOption !== 'yearWise') {
          <div class="section date-section shr_sec_box">
            <div class="section inner-section">
              <div class="label">From Date</div>
              <div class="datePopover custom-new-calendar">
                <input matInput readonly [(ngModel)]="ionFromDate" (dateChange)="hideDatePicker('start',$event)" [matDatepicker]="picker" placeholder="DD/MM/YYYY" min="1973-01-01" [max]="currentDate">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
            <div class="section inner-section">
              <div class="label">To Date</div>
              <div class="datePopover custom-new-calendar">
                <input matInput readonly [(ngModel)]="ionToDate" (dateChange)="hideDatePicker('end',$event)" [matDatepicker]="picker1" placeholder="DD/MM/YYYY" min="1973-01-01" [max]="currentDate">
                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </div>
            </div>
          </div>
        }

        <!-- drop down option for year wise selection -->
        <div class="search_filter_grid">
          @if (yearDateOption === 'yearWise') {
            <div class="section date-range-dropdown shr_sec_box pnl-date">
              <div class="label">Date Range</div>
              <ng-select class="date_select_drop" [items]="financialYrList" bindLabel="item" bindValue="value" [loading]="Loadvalue" [clearable]="false" [searchable]="false" [(ngModel)]="yearRangeValue" (change)="selectYrFromList($event)">
              </ng-select>
            </div>
          }
        </div>
        <div class="mobile-visibility search_filter_grid plstatement_tab">
          <div class="label">Report Type</div>
          <ng-select style="width: 100%;" [items]="productTypeList" bindLabel="option" bindValue="value" [loading]="Loadvalue" [clearable]="false" [searchable]="false" [(ngModel)]="productValue" (change)="panelActiveMobile(productValue)">
          </ng-select>
        </div>

      </div>
      @if (productTypeList.length > 0) {
        <div class="tab_type desktop-visibility">
          <ul class="panel-content-header">
            @for (dataObj of productTypeList; track dataObj) {
              <li
                [ngClass]="{'activePanleHead': dataObj.selected }" (click)="panelActive(dataObj.value)"
              activepanel="Cash">{{dataObj.option}}</li>
            }
          </ul>
        </div>
      }
      @if (tabPanelPnlTable == 'realised' ) {
        <div class="main_table_deta">
          @if (realizedPlObj && realizedPlObj?.product != undefined) {
            <app-realised-pnl [callFromDesktop]="true" [realizedParams]="realizedPlObj"></app-realised-pnl>
          }
        </div>
      }
      @if (tabPanelPnlTable == 'mf' ) {
        <div class="pnlmf-table">
          <div class="main-table thin-scroll scroll-inner">
            <div class="table-block header-part">
              <table class="desktop-table">
                <thead style="width: 100%">
                  <tr>
                    <th></th>
                    <th [class.active]="order === 'Scheme_Name'" (click)="setOrder('Scheme_Name')" class="pointer">Scheme Name
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Transaction_Type'" (click)="setOrder('Transaction_Type')" class="pointer">Transaction Type
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Transaction_Date'" (click)="setOrder('Transaction_Date')" class="pointer">Transaction Date
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Purchase_Price'" (click)="setOrder('Purchase_Price')" class="pointer">Purchase Price
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Units'" (click)="setOrder('Units')" class="pointer">Units
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Purchase_Amount'" (click)="setOrder('Purchase_Amount')" class="pointer">Purchase Amount
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Sell_Date'" (click)="setOrder('Sell_Date')" class="pointer">Sell Date
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Sell_Type'" (click)="setOrder('Sell_Type')" class="pointer">Sell Type
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Sell_Rate'" (click)="setOrder('Sell_Rate')" class="pointer">Sell Rate
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Sell_Amount'" (click)="setOrder('Sell_Amount')" class="pointer">Sell Amount
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'Days'" (click)="setOrder('Days')" class="pointer">Days
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <th [class.active]="order === 'GL_ST_Debt'" (click)="setOrder('GL_ST_Debt')" class="pointer">G/L ST(₹)
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <!-- <th [class.active]="order === 'GL_ST_Equity'" (click)="setOrder('GL_ST_Equity')" class="pointer">G/L ST (₹)
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th> -->
                    <th [class.active]="order === 'GL_LT_Debt'" (click)="setOrder('GL_LT_Debt')" class="pointer">G/L LT (₹)
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                    <!-- <th [class.active]="order === 'GL_LT_Equity'" (click)="setOrder('GL_LT_Equity')" class="pointer">G/L LT (Equity) (₹)
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th> -->
                    <th [class.active]="order === 'STT'" (click)="setOrder('STT')" class="pointer">STT (₹)
                      <img class="sorting-img updated-sorting-img" src="/assets/svg/sorting.svg" alt="">
                      @if (ascending) {
                        <img class="sorting-img-ascending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                      @if (!ascending) {
                        <img class="sorting-img-descending" src="/assets/svg/sorting_ascending.svg" alt="">
                      }
                    </th>
                  </tr>
                  @if (consRealizedPlList.length > 0 && tabPanelPnlLoader) {
                    <tr class="lower-header">
                      <th></th>
                      <th>Grand Total</th>
                      <th>-</th>
                      <th>-</th>
                      <th>-</th>
                      <th>{{grandTotalMFpnl.Units | formatNumerDecimal}}</th>
                      <th>{{grandTotalMFpnl.Purchase_Amount}}</th>
                      <th>-</th>
                      <th>-</th>
                      <th>-</th>
                      <th>{{grandTotalMFpnl.Sell_Amount}}</th>
                      <th>-</th>
                      <th>{{grandTotalMFpnl.GL_ST_Debt}}</th>
                      <!-- <th>{{grandTotalMFpnl.GL_ST_Equity}}</th> -->
                      <th>{{grandTotalMFpnl.GL_LT_Debt}}</th>
                      <!-- <th>{{grandTotalMFpnl.GL_LT_Equity}}</th> -->
                      <th>-</th>
                    </tr>
                  }
                </thead>
                @if (consRealizedPlList.length > 0 && tabPanelPnlLoader) {
                  <tbody>
                    @for (dataObj of consRealizedPlList | orderBy: order:sort; track dataObj; let i = $index) {
                      <tr (click)="dropClick(dataObj.srNo ,consRealizedPlList)">
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            @if (!dataObj['isVisible']) {
                              <ion-icon class="arrow-button" src="./assets/svg/down-arrow.svg"></ion-icon>
                            }
                            @if (dataObj['isVisible']) {
                              <ion-icon class="rotate arrow-button down-arrow-button" src="./assets/svg/down-arrow.svg"></ion-icon>
                            }
                          </div>
                          @if (dataObj['isVisible']) {
                            <div class="detail-part-fix" #detail>
                              <div class="table-block  detail-table-block">
                                <table class="desktop-table">
                                  <tbody>
                                    @for (detailDataObj of dataObj['Data']; track detailDataObj; let i = $index) {
                                      <tr>
                                        <td class="width-57"></td>
                                        <td></td>
                                        <td>{{detailDataObj['Transactiontype']}}</td>
                                        <td>{{detailDataObj['TransactionDate']}}</td>
                                        <td>{{detailDataObj['Purchaseprice'] | formatNumerDecimal}}</td>
                                        <td>{{detailDataObj['Units'] | formatNumerDecimal}}</td>
                                        <td>{{detailDataObj['Purchaseamount'] | formatNumerDecimal}}</td>
                                        <td>{{detailDataObj['SellDate']}}</td>
                                        <td>{{detailDataObj['SellType']}}</td>
                                        <td>{{detailDataObj['SellRate'] | formatNumerDecimal}}</td>
                                        <td>{{detailDataObj['SellAmount'] | formatNumerDecimal}}</td>
                                        <td>{{detailDataObj['NoofDays']}}</td>
                                        <td>{{detailDataObj['G_LST'] | formatNumerDecimal}}</td>
                                        <td>{{detailDataObj['G_LLT'] | formatNumerDecimal}}</td>
                                        <!-- <td>{{detailDataObj['GL_LT_Debt'] | formatNumerDecimal}}</td> -->
                                        <!-- <td>{{detailDataObj['GL_LT_Equity'] | formatNumerDecimal}}</td> -->
                                        <td>{{detailDataObj['STT'] | formatNumerDecimal}}</td>
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          }
                        </td>
                        <td>
                          <div class="upper-part justify-content-start" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            {{dataObj['Scheme_Name']}}
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            -
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            -
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            -
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            {{dataObj['Units'] | formatNumerDecimal}}
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            {{dataObj['Purchase_Amount'] | formatNumerDecimal}}
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            -
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            -
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            -
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            {{dataObj['Sell_Amount'] | formatNumerDecimal}}
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            -
                          </div>
                        </td>
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            {{dataObj['GL_ST_Debt'] | formatNumerDecimal}}
                          </div>
                        </td>
                        <!-- <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            {{dataObj['GL_ST_Equity'] | formatNumerDecimal}}
                          </div>
                        </td> -->
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            {{dataObj['GL_LT_Debt'] | formatNumerDecimal}}
                          </div>
                        </td>
                        <!-- <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            {{dataObj['GL_LT_Equity'] | formatNumerDecimal}}
                          </div>
                        </td> -->
                        <td>
                          <div class="upper-part" [ngStyle]="{'margin-bottom':  dataObj['isVisible'] ? '' + (detailHeight + 1) + 'px': ''}">
                            -
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
                <tbody>
                  @if (consRealizedPlList.length == 0 && tabPanelPnlLoader) {
                    <tr>
                      <td class="no-data-found" colspan="8" style="padding: 10px !important;">No Records Found</td>
                    </tr>
                  }
                  <tr>
                    @if (!tabPanelPnlLoader) {
                      <td colspan="8" class="text-left-loader" style="text-align: center; padding: 20px !important">
                        <img src="/assets/imgs/loader.gif" alt="" width="25px">
                      </td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
      @if (tabPanelPnlTable == 'dividend' ) {
        <div class="pnlmf-table">
          <div class="main-table thin-scroll scroll-inner">
            <div class="table-block header-part" style="width: 100%">
              <table class="desktop-table" style="width: 100%">
                <thead style="width: 100%">
                  <tr class="custTd">
                    <th style="width: 89px !important;padding-left: 8px;">Scrip Name</th>
                    <th>Date</th>
                    <th>Amount</th>
                  </tr>
                  <tr class="lower-header">
                    <th style="padding-left: 8px !important;">Grand Total</th>
                    <th>-</th>
                    <th>{{dividendTableList.Total_Dividend_Amount | formatNumerDecimal}}</th>
                  </tr>
                </thead>
                @if (dividendTableList.EquityDividend.length > 0 && dividendTableList.Total_Dividend_Amount != '' && tabPanelPnlLoader) {
                  <tbody>
                    @for (dataObj of dividendTableList.EquityDividend; track dataObj) {
                      <tr style="height: 30px;" class="custTd">
                        <!-- <td style="padding-left: 5px !important;">{{dataObj['ClientCode']}}</td> -->
                        <td style="padding-left: 8px !important;">{{dataObj['ScripName']}}</td>
                        <td>{{moment(dataObj['ExDate']).format('DD/MM/YYYY')}}</td>
                        <td>{{dataObj['Dividend_Amount'] != "" && dataObj['Dividend_Amount'] != null && dataObj['Dividend_Amount'] != undefined ? (dataObj['Dividend_Amount'] | formatNumerDecimal) : ""}}</td>
                      </tr>
                    }
                  </tbody>
                }
                <tbody>
                  @if (dividendTableList.EquityDividend.length == 0 && tabPanelPnlLoader) {
                    <tr>
                      <td class="no-data-found" colspan="8" style="padding: 10px !important;">No Records Found</td>
                    </tr>
                  }
                  <tr>
                    @if (!tabPanelPnlLoader) {
                      <td colspan="8" class="text-left-loader" style="text-align: center; padding: 20px !important">
                        <img src="/assets/imgs/loader.gif" alt="" width="25px">
                      </td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    </div>

  </div>
</ion-content>